import React from 'react';
import { i18n as I18n } from '../utils/i18n';

export const POSTCODE_REGEX = /^[A-Z]{1,2}[0-9][0-9A-Z]?\s?[0-9][A-Z]{2}$/i;

export const registrationSteps = [
  {
    number: 1,
    title: I18n.t('registration.steps.1.title'),
    content: (
      <>
        <h3>Register your FREE account</h3>
        <p>
          Register with NHS Open Space to book rooms and access a range of
          additional features, including:
        </p>
        <ul>
          <li>View floorplans and pricing</li>
          <li>Manage users on your account</li>
          <li>Manage payment methods</li>
          <li>View invoices</li>
          <li>Download reports</li>
        </ul>
        <p>
          We use your data solely for NHS Open Space purposes and we will not
          share your data with third parties.
        </p>
      </>
    ),
  },
  {
    number: 2,
    title: I18n.t('registration.steps.2.title'),
    content: (
      <>
        <h3>Company details instructions</h3>
        <p>
          Please provide details of the company under which you will be booking.
          If you do not have a registered company name, please provide your full
          name or an appropriate alternative to be used as your account name on
          the booking system.
        </p>
        <p>
          If your company name appears in the drop-down list as you type, then
          it is already registered on NHS Open Space. In this instance you can
          request to be added to the existing account by completing your
          registration.
        </p>
      </>
    ),
  },
  {
    number: 3,
    title: I18n.t('registration.steps.3.title'),
    content: (
      <>
        <h3>Service details instructions</h3>
        <p>
          Please select the service(s) for which you will be booking rooms
          through NHS Open Space.
        </p>
        <h4>Service identifiers</h4>
        <p>
          You can use the service identifier feature if you need to distinguish
          between multiple versions of a given service, for example:
        </p>
        <ul>
          <li>Diabetes (Acute)</li>
          <li>Diabetes (Community)</li>
          <li>Life Coaching (Somerset)</li>
          <li>Life Coaching (Norfolk))</li>
        </ul>
        <h4>Clinical services</h4>
        <p>
          For clinical services, please provide details of your governing body
          and registration number for that service.
        </p>
        <p>Examples of governing bodies are GMC, NMC, BACP, HCPC and CQC.</p>
        <h4>Commissioned services</h4>
        <p>
          If your service has been commissioned, please provide details of the
          commissioning body.
        </p>
      </>
    ),
  },
  {
    number: 4,
    title: I18n.t('registration.steps.4.title'),
    content: '',
  },
];
